import React, { useMemo } from 'react';

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { ChildrenPropType } from '../../../../../../prop-types/children';
import Global from '../../../../../../store/global-selectors';
import { FulfillmentDisplayContext } from '../../../../fulfillment/display-context';

const ManualFulfillmentDisplayContextProvider = ({ children, fulfillmentId }) => {
  const trackingStatus = useSelector((state) => {
    const fulfillment = Global.selectEntitiesFulfillmentById(state, {
      fulfillmentId,
    });
    return fulfillment?.trackingInformation?.status;
  });

  const value = useMemo(() => {
    return {
      trackingStatus,
    };
  }, [trackingStatus]);

  return <FulfillmentDisplayContext.Provider value={value}>{children}</FulfillmentDisplayContext.Provider>;
};

export default ManualFulfillmentDisplayContextProvider;

ManualFulfillmentDisplayContextProvider.propTypes = {
  children: ChildrenPropType.isRequired,
  fulfillmentId: PropTypes.string.isRequired,
};
